//export const WINREST_API_BASE_URL = 'https://api-dev.newrest.eu/displayeat'
export const WINREST_API_BASE_URL = 'https://newrest-api.newrest.eu/displayeat'